var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-quick-clear",style:({ right: _vm.right+'px' }),on:{"click":function($event){$event.stopPropagation();return _vm.clearTxt()}}},[_c('span',[_vm._v("×")])])}
var staticRenderFns = []

export { render, staticRenderFns }